import dayjs from "dayjs";
import { boolean, date, object, string } from "yup";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  // Left empty on purpose: the backend falls back to the purchase return's own
  // note, so an untouched field mirrors the store's wording.
  note: "",
  resend: false,
};

export const VALIDATION_SCHEMA = object().shape({
  transactionDate: date().required("Harus diisi"),
  note: string().nullable(),
  resend: boolean(),
});
